import React, {useEffect} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {Button, Dialogue, Modal, Text} from '@albert-io/atomic';
import {Link} from 'react-router';

import {useStudentDashboard} from '../StudentDashboard.store';

const AlreadyEnrolledModal = () => {
  const {duplicateClassroom, setDuplicateClassroom} = useStudentDashboard(
    useShallow((state) => ({
      duplicateClassroom: state.duplicateClassroom,
      setDuplicateClassroom: state.setDuplicateClassroom
    }))
  );

  useEffect(() => {
    return () => {
      setDuplicateClassroom(null);
    };
  }, [setDuplicateClassroom]);

  return (
    <Modal
      ariaLabel='Go to classroom'
      handleClose={() => {
        setDuplicateClassroom(null);
      }}
    >
      {({CloseButtonWrapper, modalContentStyle}) => (
        <Dialogue
          className={modalContentStyle}
          handleClose={() => setDuplicateClassroom(null)}
          inModal
          title='You already belong to that classroom'
        >
          <Dialogue.Body>
            <Text as='p'>You have already enrolled in {`${duplicateClassroom.getName()}`}!</Text>
          </Dialogue.Body>
          <div className='mt-x5 flex w-full flex-col'>
            <Button
              as={Link}
              className='mb-x1'
              to={`/classes/${duplicateClassroom.getId()}/my-assignments`}
            >
              Go to classroom
            </Button>
            <CloseButtonWrapper className='w-full'>
              <Button
                className='w-full'
                color='secondary'
                onClick={() => setDuplicateClassroom(null)}
              >
                Cancel
              </Button>
            </CloseButtonWrapper>
          </div>
        </Dialogue>
      )}
    </Modal>
  );
};

export default AlreadyEnrolledModal;
